import React, { useState } from "react";
import { FaFacebookF, FaLinkedinIn, FaMediumM, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import ReferralModal from "./ReferralModal";
import demoPdf from '../assets/images/asdflo_demo.pdf';
import LogoWithSlogan from "./LogoWithSlogan";
import GoogleBadges from "./GoogleBadges";

export default function Footer() {
  const [referralModal, setReferralModal] = useState({ open: false, role: null });

  return (
    <footer className="w-full bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-gray-200 border-t border-gray-700 shadow-2xl relative overflow-hidden">
      {/* Animated gradient background */}
      <div className="absolute inset-0 bg-gradient-to-r from-indigo-900/20 via-purple-900/20 to-blue-900/20 animate-gradient" />
      
      <div className="relative max-w-5xl mx-auto px-3 sm:px-4 lg:px-6 py-3 md:py-4">
        
        <GoogleBadges />

        {/* Top Row - Navigation Links */}
        <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm mb-5 md:mb-6 text-center">
          <a href="/about" className="text-gray-300 hover:text-white transition-colors hover:underline">About</a>
          <a href="/services" className="text-gray-300 hover:text-white transition-colors hover:underline">Services</a>
          <a href="/membership" className="text-gray-300 hover:text-white transition-colors hover:underline">Pricing</a>
          <a href="/terms-of-use" className="text-gray-300 hover:text-white transition-colors hover:underline">Terms of Use</a>
          <a href="/privacy-policy" className="text-gray-300 hover:text-white transition-colors hover:underline">Privacy Policy</a>
          <a href="/refund-policy" className="text-gray-300 hover:text-white transition-colors hover:underline">Refund Policy</a>
        </div>

        {/* Main Content */}
        <div className="flex flex-col items-center space-y-8 md:space-y-0 md:flex-row md:justify-center md:space-x-16 lg:space-x-24">
          {/* Contact Info - Centered */}
          <div className="text-center">
            <div className="flex flex-col space-y-3">
              <div className="flex items-center justify-center space-x-3">
                <img
                  src={require("../assets/asdflologoh.png")} 
                  alt="asdflo logo"
                  className="h-6 w-auto object-contain"
                  style={{ maxWidth: '24px' }}
                />
                <span 
                  className="text-xl font-bold text-white leading-none"
                >
                  asdflo
                </span>
              </div>
              
              <div className="flex flex-col space-y-2">
                <div className="flex flex-wrap gap-x-6 gap-y-2">
                  <div className="flex items-center">
                    <FaPhoneAlt className="mr-2 h-3.5 w-3.5 text-indigo-300 flex-shrink-0" />
                    <a 
                      href="tel:+918978733122" 
                      className="text-sm text-gray-300 hover:text-white transition-colors whitespace-nowrap hover:underline"
                    >
                      +91 89787 33122
                    </a>
                  </div>
                  <div className="flex items-center">
                    <FaEnvelope className="mr-2 h-3.5 w-3.5 text-indigo-300 flex-shrink-0" />
                    <a 
                      href="mailto:info@asdflo.com" 
                      className="text-sm text-gray-300 hover:text-white transition-colors whitespace-nowrap hover:underline"
                    >
                      info@asdflo.com
                    </a>
                  </div>
                </div>
                
                <div className="flex items-center justify-center space-x-6 pt-4">
                  {[
                    { icon: FaFacebookF, url: "https://www.facebook.com/profile.php?id=61575316464563" },
                    { icon: FaLinkedinIn, url: "https://www.linkedin.com/in/asd-flo-558057360/" },
                    { icon: FaMediumM, url: "https://medium.com/@asdfloteam" }
                  ].map((social, index) => (
                    <a 
                      key={index}
                      href={social.url}
                      aria-label={social.icon.name}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-400 hover:text-white transition-all duration-300 transform hover:scale-125"
                    >
                      <social.icon className="h-5 w-5" />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="mt-6 pt-4 border-t border-gray-800/50">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-3 md:space-y-0">
            <div className="flex items-center space-x-2">
              <svg className="w-4 h-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
              </svg>
              <span className="text-xs text-gray-500">
                {new Date().getFullYear()} asdflo Innovations OPC Pvt Ltd • CIN: U12345MH2025OPC123456
              </span>
            </div>
          </div>
        </div>
      </div>
      <ReferralModal open={referralModal.open} onClose={() => setReferralModal({ open: false, role: null })} defaultRole={referralModal.role} />
    </footer>
  );
}
